<div class="flex flex-col w-full p-6 bg-background-primary rounded-md shadow-md">
    <div class="flex flex-row justify-center">
        <mat-spinner></mat-spinner>
    </div>
    <div class="flex flex-row justify-center text-center text-xl font-semibold mt-4">
        {{ content }}
    </div>
</div>